import { Tool } from '~/packages/tools/tools.typing'
import fetchDistinctLegalEntitiesEmissorNfeSizeAction from './queries/distinctLegalEntitiesEmissorNfeSize/distinctLegalEntitiesEmissorNfeSize.action.json'
import expression from '~/prix/types/expression'
import { distinctEmissorNfeStatsExpression } from '../distinctLegalEntitiesEmissorNfe/stats/distinctLegalEntitiesEmissorNfeStats.definition'
import { pick } from '~/prix/utils/types/object'

type DistinctLegalEntitiesEmissorNfeSizeMapFilterableByKey =
  | 'ageGroup'
  | 'segmentId'
  | 'registrationStatus'

const distinctLegalEntitiesEmissorNfeSizeMapFilterableByKeys: DistinctLegalEntitiesEmissorNfeSizeMapFilterableByKey[] =
  ['ageGroup', 'segmentId', 'registrationStatus']

export const getDistinctLegalEntitiesEmissorNfeSizeMapFilterableBy = () =>
  expression({
    ...pick(
      distinctEmissorNfeStatsExpression.shape,
      distinctLegalEntitiesEmissorNfeSizeMapFilterableByKeys,
    ),
  })

export const distinctLegalEntitiesEmissorNfeSizeMapTool = {
  key: 'distinctLegalEntitiesEmissorNfeSizeMap',
  title: 'Distribuição territorial por porte do Emissor NF-e',
  label: 'Empresas distintas atendidas por porte do Emissor NF-e',
  categoryKey: 'distinctLegalEntitiesEmissorNfe',
  categoryKeys: ['distinctLegalEntitiesEmissorNfe'],
  unitSingular: 'empresa atendida',
  unitPlural: 'empresas atendidas',
  grammaticalGender: 'male',
  path: '/app/map/distinct-legal-entities-emissor-nfe-size',
  timeType: 'incidence',
  restrictView: ['space'],
  actionDefinitionKey: fetchDistinctLegalEntitiesEmissorNfeSizeAction.key,
  isListed: true,
  filterableBy: getDistinctLegalEntitiesEmissorNfeSizeMapFilterableBy(),
} satisfies Tool & { actionDefinitionKey: string }

export default async function getDistinctLegalEntitiesEmissorNfeSizeMapTools() {
  return [distinctLegalEntitiesEmissorNfeSizeMapTool]
}
